export default function (ModalService) {
    return function (existingDealer, existingBranch) {
        return ModalService.showModal({
            controller: require('../../controllers/addVmcAccount/addVmcAccountCtrl'),
            template: require('../../controllers/addVmcAccount/addVmcAccount.html'),
            controllerAs: 'addVmcAccount',
            inputs: {
                existingDealer,
                existingBranch
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/addVmcAccount/openAddVmcAccountModal.js